// Merkzettel-Liste: Bei Klick auf das "Karte"-Icon muss das aktive Tab auch auf "Karte" wechseln
if ($(".listItemWrapperMerkzettel").length) {
    $('.ttgIconShowOnMap').addClass('ttgDisplayNone');
}

// Merkzettel-Liste: Kategorie sichtbar machen
if ($(".listItemWrapperMerkzettel").length) {
    if ($(".ttgMerkzettelCategory").length) {
        $('.ttgMerkzettelCategory').each(function() {
            $(this).removeClass('ttgDisplayNone');
        });
    }

    // ToolTips wiederherstellen
    $(".ttgMetaSearchIcons").children().each(function() {
        if ($(this).attr("data-titleMerkzettel")) {
            $(this).attr("title", $(this).attr("data-titleMerkzettel"));
            //alert ($(this).attr("data-titleMerkzettel"));
        }
    });

}

// Merken-Button auf TOURDATA Liste
$('#td').on('click', "button.ttgBeitragMerken", function() {
    addToMerkListe($(this).children().first());
    if ($(this).hasClass("ttgBeitragMerkenActive")) {
        $(this).removeClass("ttgBeitragMerkenActive");
        $(this).children('.merkenBtnSmall').removeClass('fa-solid').addClass('fa-regular');
        $(this).find("span.merken").html($(this).data("beitragmerkentext"));
        console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', $(this).find("span.merken").html());
    } else {
        $(this).addClass("ttgBeitragMerkenActive");
        $(this).children('.merkenBtnSmall').removeClass('fa-regular').addClass('fa-solid');
        $(this).find("span.merken").html($(this).data("beitraggemerkttext"));
    }
    $(this).attr("title", $(this).attr("data-textremove"));
});

var merkZettelItems = $.cookie('merkZettelItems');

if (merkZettelItems == null) {
    merkZettelItems = "";
}

var merkZettelArray = [];

if (merkZettelItems.length > 0) {
    merkZettelArray = merkZettelItems.split(",");
    // Anzahl der Merkzettel-Items in der Navigation ausgeben - zu Beginn: 0
    var anzahlItems = merkZettelArray.length;
    // $('.ttgQuickNaviListItemSprechblase').html(anzahlItems);
    $('.ttgQuickNaviMerkzettel .indicator').addClass('show');
} else {
    // $('.ttgQuickNaviListItemSprechblase').html("0");
    $('.ttgQuickNaviMerkzettel .indicator').removeClass('show');
}

var tag = "*[data-typ][data-id]";
$(tag).each(function() {
    if (merkZettelArray.length > 0) {
        for (var i = 0; i < merkZettelArray.length; i++) {
            if ($(this).data("typ") + "" + $(this).data("id") == (merkZettelArray[i])) {
                if ($(this).hasClass('iconMerkenSmall')) {
                    $(this).removeClass("iconMerkenSmall").addClass("iconMerkenSmallActive");
                    $(this).parent().addClass("ttgBeitragMerkenActive");
                    $(this).parent().parent().addClass("ttgBeitragMerkenActiveParent");
                    $(".ttgBeitragMerkenText").html($(this).parent().attr("data-beitragGemerktText"));
                }
                if ($(this).hasClass('merken-liste')) {
                    $(this).parent().addClass("ttgBeitragMerkenActive");
                    $(this).removeClass('fa-regular').addClass('fa-solid');
                    $(this).siblings("span").children(".merken").html($(this).parent().attr("data-beitragGemerktText"));
                }
            }
        }
    }
});

// Merken-Button als Ganzes klickbar machen
if ($("#ttgBeitragMerken").length) {
    $("#ttgBeitragMerken").click(function() {
        addToMerkListe($(this).children().first());
        if ($(this).hasClass("ttgBeitragMerkenActive")) {
            $(this).removeClass("ttgBeitragMerkenActive");
            $(this).parent().removeClass("ttgBeitragMerkenActiveParent");
            $(this).children('.merkenBtnSmall').removeClass('iconMerkenSmallHover');
            $(".ttgBeitragMerkenText").html($(this).attr("data-beitragMerkenText"));
            $(this).children().first().addClass("iconMerkenSmall").removeClass("iconMerkenSmallActive");
        } else {
            $(this).addClass("ttgBeitragMerkenActive");
            $(this).parent().addClass("ttgBeitragMerkenActiveParent");
            $(".ttgBeitragMerkenText").html($(this).attr("data-beitragGemerktText"));
            $(this).children().first().addClass("iconMerkenSmallActive").removeClass("iconMerkenSmall");
        }
        $(this).attr("title", $(this).attr("data-textremove"));
    });
}

// Hover auf Löschen-Icon
$('.ttgMerkzettelLoeschen').mouseover(function() {
    $(this).addClass('ttgMerkzettelLoeschenActive');
}).mouseout(function() {
    $(this).removeClass('ttgMerkzettelLoeschenActive');
});

// Drag & Drop Sortierung auf der Merkzettel-Seite
if ($('.ttgMerkzettelListItems').length) {
    if ($(window).width() > 768) {
        $('.ttgMerkzettelListItems').sortable();
    } else {
        $('.ttgMerkzettelListItems').sortable({
            disabled: true
        });
    }
}


function getToolTipHTML(toolTipText) {

    return '<div class="tooltipTop"></div><div class="tooltipMiddle">' + toolTipText + '</div><div class="tooltipBottom"></div>';

}

function addToMerklistenCookie(typ, id) {

    var merkZettelId = typ + "" + id;
    var storedMerkZettelIds = $.cookie('merkZettelItems');
    if (storedMerkZettelIds == null) {
        storedMerkZettelIds = "";
    }

    if (storedMerkZettelIds) {
        storedMerkZettelIds = checkIfMerkZettelIdIsUnique(storedMerkZettelIds, merkZettelId);
    } else {
        storedMerkZettelIds = merkZettelId;
    }

    // Anzahl der Merkzettel-Items in der Navigation ausgeben
    var merkZettelArray = storedMerkZettelIds.split(",");
    var anzahlItems = merkZettelArray.length;
    if (anzahlItems > 0) {
        // $('.ttgQuickNaviListItemSprechblase').html(anzahlItems);
        $('.ttgQuickNaviMerkzettel .indicator').addClass('show');
    }

    if ($('.ttgDataWrapperOnlyNeededForJS').attr('data-googleanalyticsactive') == 1) {
        trackEvent('Global', 'Merkzettel', 'Objekt hinzugefügt');
    }

    $.cookie('merkZettelItems', storedMerkZettelIds, {
        expires: 0,
        path: '/'
    });
}

function deleteFromMerklistenCookie(typ, id) {

    var uniqueNewArray = [];
    var storedMerkZettelIds = $.cookie('merkZettelItems');
    if (storedMerkZettelIds == null) {
        storedMerkZettelIds = "";
    }
    if (storedMerkZettelIds) {
        var storedMerkZettelArray = storedMerkZettelIds.split(",");
        if (storedMerkZettelArray.length > 0) {
            for (var i = 0; i < storedMerkZettelArray.length; i++) {
                if (storedMerkZettelArray[i] == typ + "" + id) {
                    storedMerkZettelArray.splice(i, 1);
                }
            }
        }

        uniqueNewArray = $.unique(storedMerkZettelArray);
        storedMerkZettelIds = uniqueNewArray.join(",");

        $.cookie('merkZettelItems', storedMerkZettelIds, {
            expires: 0,
            path: '/'
        });
    }

    // Anzahl der Merkzettel-Items in der Navigation ausgeben
    if (uniqueNewArray.length) {
        var anzahlItems = uniqueNewArray.length;
        // $('.ttgQuickNaviListItemSprechblase').html(anzahlItems);
        if (anzahlItems > 0) {
            $('.ttgQuickNaviMerkzettel .indicator').addClass('show');
        } else {
            $('.ttgQuickNaviMerkzettel .indicator').removeClass('show');
        }
    }

    if ($('.ttgDataWrapperOnlyNeededForJS').attr('data-analyticsactive') == 1) {
        trackEvent('Global', 'Merkzettel', 'Objekt hinzugefügt');
    }

}

function checkIfMerkZettelIdIsUnique(merkZettelIds, newId) {

    merkZettelIds = merkZettelIds + "," + newId;
    var nArray = merkZettelIds.split(",");
    uniqueArray = $.unique(nArray);
    return uniqueArray.join(",");

}

function deleteMerkZettelItem(typ, uid, merkZettelURL) {

    var ajaxUrl = "/?merkzettel=saveList";

    var thisParams = "typ=" + typ + "&uid=" + uid + "&todo=delMandant";

    $.ajax({
        type: "POST",
        url: ajaxUrl,
        data: thisParams,
        beforeSend: function(e) {},
        success: function(e) {
            deleteFromMerklistenCookie(typ, uid);
            if (merkZettelURL.length > 0) {
                window.location.href = merkZettelURL;
            }
        },
        error: function(e) {
            if (merkZettelURL.length > 0) {
                window.location.href = merkZettelURL;
            }
        }
    }); // ajax
    return false;

}

function addToMerkListe(obj) {

    var ajaxUrl = "/?merkzettel=saveList";
    var url = obj.attr("data-url");
    var typ = obj.attr("data-typ");
    var id = obj.attr("data-id");
    var title = obj.attr("data-title");
    var image = obj.attr("data-image");
    var text = $.trim(obj.attr("data-text"));
    var lat = obj.attr("data-lat");
    var lon = obj.attr("data-lon");
    var imageClass = obj.attr("data-imageClass");
    var ort = obj.attr("data-ort");
    var categories = obj.attr("data-categories");
    var alt = obj.attr("data-image-alt");
    var copyright = obj.attr("data-image-copyright");
    var infoWindow = $.trim(obj.attr("data-infowindow"));

    // melaande - 7.10. - OOEAT-38
    var completeitem = obj.attr("data-completeitem");

    var thisParams = {

        url: url,
        uid: id,
        typ: typ,
        title: title,
        image: image,
        text: text,
        lat: lat,
        lon: lon,
        imageclass: imageClass,
        ort: ort,
        categories: categories,
        alt: alt,
        copyright: copyright,
        infowindow: infoWindow,

        // melaande - 7.10. - OOEAT-38
        completeitem: completeitem,

        todo: 'addMandant'
    };

    $.ajax({
        type: "POST",
        url: ajaxUrl,
        data: thisParams,
        beforeSend: function(e) {
            //alert(clickedElement.attr('class'));
            //thisAjaxLoader.show();
        },
        success: function(e) {
            //alert("here");
            // $.getScript($('base').attr('href')+"/fileadmin/templates/global/js/ajax/ajax.merkzettel.js");
            if (e == "added_to_notepad") {
                addToMerklistenCookie(typ, id);
                // ändern des Tooltip Textes soll der Text "Beitrag gemerkt" angezeigt werden + nach 2 Sekunden wird der Tooltip wieder ausgeblendet
                obj.attr("title", obj.attr("data-beitragGemerktTextInfo"));
                obj.attr("data-original-title", obj.attr("data-beitragGemerktTextInfo"));
                //				obj.tooltip('show');

                if (obj.hasClass('iconMerkenSmallActive')) {
                    obj.attr("title", obj.attr("data-textremove"));
                    obj.attr("data-original-title", obj.attr("data-textremove"));
                }

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                return false;
            }
            if (e == "delete_from_notepad") {
                deleteFromMerklistenCookie(typ, id);
                obj.attr("title", obj.attr("data-beitragEntferntTextInfo"));
                obj.attr("data-original-title", obj.attr("data-beitragEntferntTextInfo"));
                //				obj.tooltip('show');

                if (obj.hasClass('iconMerkenSmallActive')) {
                    obj.removeClass('iconMerkenSmallActive').addClass('iconMerkenSmall');
                    obj.attr("title", obj.attr("data-textadd"));
                    obj.attr("data-original-title", obj.attr("data-textadd"));
                }

                if (obj.hasClass('ttgMerkzettelIconActive')) {
                    obj.removeClass('ttgMerkzettelIconActive').addClass('ttgMerkzettelIcon');
                    obj.attr("title", obj.attr("data-textadd"));
                }

                return false;
            }
        },
        error: function(e) {
            //thisAjaxLoader.hide();
        }
    });
    return false;

}